import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { CompaniesSummaryRecord } from 'src/models';
import { RootState } from 'src/store';
import { companiesSummarySelectors } from 'src/store/reducers/companiesSummary';

export const useCompaniesSummaryState = (): RootState['companiesSummary'] => {
  const state = useSelector<RootState, RootState['companiesSummary']>(
    (state) => state.companiesSummary,
  );

  useDebugValue(state);

  return state;
};

export const useCompaniesSummary = (): CompaniesSummaryRecord[] => {
  const state = useSelector<RootState, RootState['companiesSummary']>(
    (state) => state.companiesSummary,
  );

  const records = companiesSummarySelectors.selectAll(state);

  useDebugValue(state);

  return records;
};
